export class Convocatoria {
    IdConvocatoria: number;
    CodigoConvocatoria: string;
    Resolucion: string;
    FechaInicio: string;
    FechaFin: string;
    TotalBonos: number;
    CantBonosElegibles: number;
    CantBonosDisponibles: number;
    IndicadorEsNacional: number;
    Estado: number;
    UsuarioCreacion: string;
    FechaCreacion: Date;
    UsuarioModificacion: string;
    FechaModificacion: Date;
    ListaConvocatoriaDet: Array<ConvocatoriaDet>;
    NombreEstado: string;
}

export class ConvocatoriaDet {
  IdConvocatoria: number;
  IdProvincia: number;
  IdDepartamento: number;
  CodConvocatoriaZona: string;
  TotalBonoDepa: number;
  CantBonoElegible: number;
  CantBonoDisponible: number;
  Estado: number;
  UsuarioCreacion: string;
  FechaCreacion: Date;
  UsuarioModificacion: string;
  FechaModificacion: Date;
  CodigoConvocatoria: string;
  Disable = false;
}
